module.exports = __webpack_public_path__ + "img/img (15).b5885078.jpg";